import $ from 'jquery'

export const registerExtensions = () => {
    // jQuery
    jQueryRotateExt()
    jQueryRegexExt()
    jQueryHasAttrExt()
    jQueryHasSelectExt()

    // Window / Document
    consoleLogExt()
}

const jQueryRotateExt = () => {
    $.fn.rotate = ($elem) => {
        const ROTATION_DELAY = 15 // ms - between each tic
        let rotation = 0 // ° - degree

        setInterval(() => {
            $elem.css({ transform: 'rotate(' + rotation + 'deg)', zoom: 1 })
            rotation++
        }, ROTATION_DELAY)
    }
}

const jQueryRegexExt = () => {
    $.expr.pseudos.regex = $.expr.createPseudo((expression) => {
        return (elem) => {
            const matchParams = expression.split(',')
            const validLabels = /^(id|class|attr|css|data|name):/
            const regexFlags = 'ig' // [i]gnore case, [g]lobal
            const attr = {
                method: matchParams[0].match(validLabels) ? matchParams[0].split(':')[0] : 'attr',
                property: matchParams.shift().replace(validLabels, ''),
            }

            const regExp = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g, ''), regexFlags)

            return regExp.test($(elem)[attr.method](attr.property))
        }
    })
}

const jQueryHasAttrExt = () => {
    $.fn.hasAttr = function (name) {
        return this.attr(name) !== undefined // Will it work with => fn ?
    }
}

const jQueryHasSelectExt = () => {
    $.fn.hideOption = function (optionValue) {
        const $select = $(this)
        if (!$select.is('select')) return
        if (Array.isArray(optionValue)) {
            optionValue.forEach((value) => {
                const $option = $select.find(`option[value="${value}"]`)
                $option.is(':selected') && $select.prop('selectedIndex', 0)
                $option.hide()
                $option.prop('hidden', true)
            })
        } else if (typeof optionValue === 'string') {
            const $option = $select.find(`option[value="${optionValue}"]`)
            $option.is(':selected') && $select.prop('selectedIndex', 0)
            $option.hide()
            $option.prop('hidden', true)
        }
        $select.change()
    }
    $.fn.showOption = function (optionValue) {
        const $select = $(this)
        if (!$select.is('select')) return
        if (Array.isArray(optionValue)) {
            optionValue.forEach((value) => {
                const $option = $select.find(`option[value="${value}"]`)
                $option.show()
                $option.prop('hidden', false)
            })
        } else if (typeof optionValue === 'string') {
            const $option = $select.find(`option[value="${optionValue}"]`)
            $option.show()
            $option.prop('hidden', false)
        }
    }
    $.fn.showAllOptions = function () {
        const $select = $(this)
        if (!$select.is('select')) return
        $select.find(`option`).each(function () {
            $(this).show()
            $(this).prop('hidden', false)
        })
    }
    $.fn.isOptionHidden = function (optionValue) {
        const $select = $(this)
        if (!$select.is('select')) return
        const $option = $select.find(`option[value="${optionValue}"]`) //$elementIsVisible()
        return $option.prop('hidden')
    }
}

const consoleLogExt = () => {
    window.d = window.dump = window.log = console.log
}
